import { MessagePaths, useMessagesTranslation } from '@shared/i18n';
import { ChangelogResources } from '../types/ChangelogLanguageResources';

export const useChangelogTranslation = () => useMessagesTranslation<ChangelogResources>();

export type ChangelogMessageKey = MessagePaths<ChangelogResources>;

export const useChangelogTFunction = () => useChangelogTranslation().t;

export type ChangelogTFunction = ReturnType<typeof useChangelogTFunction>;
